/**
 * API Client Functions für User Settings
 * 
 * Endpoints unter /api/v1/settings
 */

import { apiClient } from '@/lib/api-client';
import type {
  UserSettings,
  UserSettingsUpdate,
  UserSettingsResponse,
  UserSettingsUpdateResponse,
  PresetOption,
  PresetsResponse,
  SettingsOptions,
  SettingsOptionsResponse,
} from '@/types/settings';

// ===========================================
// USER SETTINGS
// ===========================================

/**
 * Lädt die aktuellen User-Settings
 */
export async function getUserSettings(): Promise<UserSettings> {
  const response = await apiClient.get<UserSettingsResponse>('/api/v1/settings');
  
  if (!response.data.success) {
    throw new Error('Einstellungen konnten nicht geladen werden');
  }
  
  return response.data.settings;
}

/**
 * Aktualisiert User-Settings
 */
export async function updateUserSettings(
  settings: UserSettingsUpdate
): Promise<UserSettingsUpdateResponse> {
  const response = await apiClient.put<UserSettingsUpdateResponse>(
    '/api/v1/settings',
    settings
  );
  
  return response.data;
}

/**
 * Lädt alle verfügbaren Presets (Standard + Custom)
 */
export async function getAvailablePresets(): Promise<PresetOption[]> {
  const response = await apiClient.get<PresetsResponse>('/api/v1/settings/presets');
  
  if (!response.data.success) {
    throw new Error('Presets konnten nicht geladen werden');
  }
  
  return response.data.presets;
}

/**
 * Lädt alle verfügbaren Optionen für Settings-Dropdowns
 */
export async function getSettingsOptions(): Promise<SettingsOptions> {
  const response = await apiClient.get<SettingsOptionsResponse>('/api/v1/settings/options');
  
  if (!response.data.success) {
    throw new Error('Optionen konnten nicht geladen werden');
  }
  
  return response.data.options;
}

// ===========================================
// HELPER TYPES
// ===========================================

/**
 * TanStack Query Keys für Settings
 */
export const settingsQueryKeys = {
  all: ['settings'] as const,
  user: () => [...settingsQueryKeys.all, 'user'] as const,
  presets: () => [...settingsQueryKeys.all, 'presets'] as const,
  options: () => [...settingsQueryKeys.all, 'options'] as const,
};





